module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-600.3db5529.ttf";